import {
  TextField,
  Box,
  Stack,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  ToggleButton,
  Switch,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { axiosGetCall, axiosPatchCall } from 'src/services/apisCall';
import { LoadingButton } from '@mui/lab';
import Iconify from 'src/components/iconify';
import Logger from 'src/lib/Logger';
import { renderErrorMessage, renderSuccessMessage } from 'src/lib/toastMessage';

const logger = new Logger('asetting');

const requestList = [
  { label: 'Self', value: 'U' },
  { label: 'Downline', value: 'D' },
  { label: 'Hierarchy', value: 'H' },
];

const SwitchButton = styled(Switch)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#65C466',
        opacity: 1,
        border: 0,
      },
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.5,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 13,
    backgroundColor: theme.palette.grey[500],
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 300,
    }),
  },
}));


const SmsCutting = ({ user }) => {
  const inputSx = {
    color: 'grey.900',
    borderColor: 'grey.700',
    borderRadius: '6px',
  };


  const [startingRange, setStartingRange] = useState(0);
  const [endingRange, setEndingRange] = useState(0);
  const [startCuttingPercentage, setStartCuttingPercentage] = useState(0);
  const [endCuttingPercentage, setEndCuttingPercentage] = useState(0);
  const [cuttingRequestFor, setCuttingRequestFor] = useState('U');

  const [load, setLoad] = useState(false);
  const [cuttingLoader, setCuttingLoader] = useState(false);
  const [cuttingToggle, setCuttingToggle] = useState('api');
  const [userMockEnabled, setUserMockEnabled] = useState(false);
  const [isUserMockLoading, setIsUserMockLoading] = useState(true);
  const [isUserMockUpdating, setIsUserMockUpdating] = useState(false);

  const userId = user?.userId;
  const userType = user?.voiceInfo?.userType || user?.userType;


  const updateCuttingPercentage = async () => {
    try {
      if (parseInt(startCuttingPercentage) > parseInt(endCuttingPercentage)) {
        return renderErrorMessage('Start Cutting Percentage must be less than End Cutting Percentage');
      }

      if (
        parseInt(startCuttingPercentage) === parseInt(endCuttingPercentage) &&
        parseInt(startCuttingPercentage) !== 0
      ) {
        return renderErrorMessage('Start Cutting Percentage and End Cutting Percentage not be same');
      }

      const payload = {
        userId: user?.userId,
        action: 'setCutting',
        startingRange: parseInt(startingRange),
        endingRange: parseInt(endingRange),
        startCuttingPercentage: parseInt(startCuttingPercentage),
        endCuttingPercentage: parseInt(endCuttingPercentage),
        cuttingType: cuttingToggle,
        mockToAnswer: 0,
        requestFor: 'U',
      };

      if (user?.voiceInfo?.userType === 'reseller') {
        payload.requestFor = cuttingRequestFor;
      }

      setCuttingLoader(true);
      await axiosPatchCall('updateSmsProfileSetting', payload);
      setCuttingLoader(false);
      fetchSettingDetails(cuttingToggle);
      renderSuccessMessage('Success');
    } catch (error) {
      logger.error(error);
      setCuttingLoader(false);
      renderErrorMessage(error.message);
    }
  };


  const handleReset = async (type) => {
    let payload = {
      userId: user?.userId,
      action: 'resetSetting',
      resetActionType: '',
      requestFor: 'U',
    };

    if (type === 'cutting') {
      payload.resetActionType = 'setCutting';
      payload.requestFor = cuttingRequestFor;
      payload.cuttingType = cuttingToggle;
    }
    try {
      await axiosPatchCall('updateSmsProfileSetting', payload);
      renderSuccessMessage(`Success`);
      setLoad((prev) => !prev);
    } catch (error) {
      logger.error(error);
      renderErrorMessage(error.message);
    }
  };


  const handleSubmit = async (type) => {


    if (type === 'cutting') {
      await updateCuttingPercentage();
    }
  };

  const fetchSettingDetails = async (cuttingToggle) => {
    try {
      const {
        data: { startingRange, endingRange, startCuttingPercentage, endCuttingPercentage },
      } = await axiosGetCall('getSmsUserSettingInfo', {
        requestName: 'setCutting',
        requestUserId: user?.userId,
        cuttingType: cuttingToggle,
      });
      setStartCuttingPercentage(startCuttingPercentage);
      setStartingRange(startingRange);
      setEndingRange(endingRange);
      setEndCuttingPercentage(endCuttingPercentage);

    } catch (error) {
      logger.error(error);
    }
  };

  const fetchUserMockReportStatus = async () => {
    setIsUserMockLoading(true);

    try {
      const { data = {} } = await axiosGetCall('getSmsUserSettingInfo', {
        requestName: 'getUserMockReportStatus',
        requestUserId: userId,
      });
      const status = data?.mockReportStatus;
      setUserMockEnabled(status === true || status === 1 || status === '1' || status === 'true');
    } catch (error) {
      logger.error(error);
      renderErrorMessage(error.message);
    } finally {
      setIsUserMockLoading(false);
    }
  };

  const handleUserMockChange = async (event) => {
    const previousStatus = userMockEnabled;
    const status = event.target.checked;

    setUserMockEnabled(status);
    setIsUserMockUpdating(true);

    try {
      const result = await axiosPatchCall('updateSmsProfileSetting', {
        action: 'updateUserMockReportStatus',
        userId,
        userType,
        requestFor: 'U',
        status,
      });
      renderSuccessMessage(result?.message || 'User mock setting updated successfully');
    } catch (error) {
      logger.error(error);
      setUserMockEnabled(previousStatus);
      renderErrorMessage(error.message);
    } finally {
      setIsUserMockUpdating(false);
    }
  };

  useEffect(() => {
    fetchSettingDetails(cuttingToggle);
  }, [load, cuttingToggle]);

  useEffect(() => {
    if (userId) {
      fetchUserMockReportStatus();
    }
  }, [userId]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        overflow: 'hidden',
        overflowY: 'scroll',
        scrollbarWidth: 'none',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '18px' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '3px',
            padding: '6px',
            width: '70%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: '6px',
              mb: '15px',
            }}
          >
            <ToggleButton
              sx={{ border: 'none' }}
              value="api"
              selected={cuttingToggle === 'api'}
              onChange={() => setCuttingToggle('api')}
            >
              API
            </ToggleButton>
            <ToggleButton
              sx={{ border: 'none' }}
              value="regular"
              selected={cuttingToggle === 'regular'}
              onChange={() => setCuttingToggle('regular')}
            >
              Regular
            </ToggleButton>
          </Box>
          <Box>
            <Box
              sx={{
                display: 'flex',
                gap: '6px',
                mb: '15px',
              }}
            >
              <TextField
                fullWidth
                id="outlined-basic"
                label="Starting Range"
                type="number"
                variant="outlined"
                InputProps={{
                  sx: inputSx,
                }}
                value={startingRange}
                onChange={(e) => setStartingRange(e.target.value)}
                size="small"
              />

              <TextField
                fullWidth
                id="outlined-basic"
                label="Ending Range"
                type="number"
                variant="outlined"
                InputProps={{
                  sx: inputSx,
                }}
                value={endingRange}
                onChange={(e) => setEndingRange(e.target.value)}
                size="small"
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                gap: '6px',
                mb: '15px',
              }}
            >
              <TextField
                fullWidth
                id="outlined-basic"
                label="Start Cutting Percentage"
                type="number"
                variant="outlined"
                InputProps={{
                  sx: inputSx,
                }}
                value={startCuttingPercentage}
                onChange={(e) => setStartCuttingPercentage(e.target.value)}
                size="small"
              />
              <TextField
                fullWidth
                id="outlined-basic"
                label="End Cutting Percentage"
                type="number"
                variant="outlined"
                InputProps={{
                  sx: inputSx,
                }}
                value={endCuttingPercentage}
                onChange={(e) => setEndCuttingPercentage(e.target.value)}
                size="small"
              />
            </Box>
          </Box>

          <Stack width={'100%'} direction={'row'} alignItems={'center'}>
            {user?.voiceInfo?.userType === 'reseller' && (
              <Stack
                gap={2}
                direction={'row'}
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  mb: '10px',
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="request-select">Request For</InputLabel>
                  <Select
                    labelId="request-select"
                    id="request-select"
                    value={cuttingRequestFor || ''}
                    onChange={(e) => setCuttingRequestFor(e?.target?.value)}
                    label="Request For"
                    size="small"
                    displayEmpty
                  >
                    {requestList.map(({ label, value }) => (
                      <MenuItem key={label} value={value}>
                        {label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>
            )}
          </Stack>
          </Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-end', width: '30%', mb: '20px', paddingBottom: '6px' }}>
          <Stack width={'100%'} direction={'row'} alignItems={'center'}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Stack direction={'row'} gap={1}>
                <IconButton onClick={() => handleReset('cutting')}>
                  <Iconify icon="ix:reset" />
                </IconButton>
                <LoadingButton
                  loading={cuttingLoader}
                  variant="contained"
                  sx={{ width: '100px' }}
                  onClick={() => handleSubmit('cutting')}
                >
                  Submit
                </LoadingButton>
              </Stack>
            </Box>
          </Stack>
          </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          mx: '6px',
          p: '16px',
          maxWidth: '70%',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: '8px',
          backgroundColor: 'background.paper',
        }}
      >
        <Typography variant="subtitle1" sx={{ color: 'text.primary', fontWeight: 600 }}>
          User Mock
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
          Note: When User Mock is enabled, campaigns sent by this user will not deliver real SMS
          messages to regular recipients. Real SMS messages will be delivered only to mobile numbers
          added to the SMS Real Number list for testing. If Universal Mock is active, it overrides
          this user-level setting.
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Typography sx={{ color: 'grey.700', fontWeight: 500 }}>
            Enable User Mock
          </Typography>
          <SwitchButton
            checked={userMockEnabled}
            onChange={handleUserMockChange}
            disabled={isUserMockLoading || isUserMockUpdating}
            inputProps={{ 'aria-label': 'User mock setting' }}
          />
          <Typography
            sx={{
              color: userMockEnabled ? 'success.main' : 'text.secondary',
              fontSize: '0.875rem',
              fontWeight: 600,
              minWidth: '70px',
            }}
          >
            {isUserMockLoading ? 'Loading...' : userMockEnabled ? 'Active' : 'Not Active'}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SmsCutting;
